import { isModuleLoadError } from "../components/errors/errorConfig";

// Keep retries brief: total backoff is ~5s before the existing error UI.
export const DEFAULT_RETRY_DELAYS_MS = [500, 1500, 3000] as const;

export async function loadModuleWithRetry<T>(
  loadModule: () => Promise<T>,
  retryDelaysMs: readonly number[] = DEFAULT_RETRY_DELAYS_MS,
): Promise<T> {
  let attempt = 0;

  while (true) {
    try {
      return await loadModule();
    } catch (error) {
      if (!isModuleLoadError(error) || attempt >= retryDelaysMs.length) {
        throw error;
      }

      await new Promise((resolve) => setTimeout(resolve, retryDelaysMs[attempt]));
      attempt++;
    }
  }
}
